import React, { Fragment } from 'react';
import Select from 'react-select';

export default function DropDown({
	label,
	noMargin,
	placeholder = 'placeholder',
	value,
	onChange,
	name,
	disabled,
	error,
	message,
	options
}) {
	return (
		<div className="">
			{label && <label className="w-full form-label font-bold inline-block mt-1 text-gray-700">{label}</label>}
			<Select
				className="form-control border rounded"
				options={options}
				value={options.filter((option) => option.value === value)}
				name={name}
				id={name}
				placeholder={placeholder}
				isDisabled={disabled}
				onChange={onChange}
			/>
			{message}
			{error && <div className="text-red-600">{error}</div>}
		</div>
	);
}
